import React, { Fragment, useEffect, useState } from "react";
import { generateOTPApi, verifyOtpApi } from "../utils/api";
import { ClipLoader } from "react-spinners";
import { FiEdit3 } from "react-icons/fi";
// import { useJitsu } from "@jitsu/react";

function Login({
  settings,
  phone,
  email,
  setPhone,
  setEmail,
  setOtpVerified,
  otpSent,
  setOtpSent,
  trackOrders,
  accessToken,
  setAccessToken,
}) {
  const [otpNumber1, setOtpNumber1] = useState("");
  const [otpNumber2, setOtpNumber2] = useState("");
  const [otpNumber3, setOtpNumber3] = useState("");
  const [otpNumber4, setOtpNumber4] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  const [inputError, setInputError] = useState(false);
  const [otpError, setOtpError] = useState(false);
  // const { id, track } = useJitsu();

  const handleLength = (e) => {
    const { maxLength, value, name } = e.target;
    // eslint-disable-next-line
    const [fieldName, fieldIndex] = name.split("-");

    // Check if they hit the max character length
    if (value.length >= maxLength) {
      // Check if it's not the last input field
      if (parseInt(fieldIndex, 10) < 6) {
        // Get the next input field
        const nextSibling = document.querySelector(
          `input[name=otp-${parseInt(fieldIndex, 10) + 1}]`
        );

        // If found, focus the next field
        if (nextSibling !== null) {
          nextSibling.focus();
        }
      }
    }
  };

  const handleUser = (e) => {
    let editedValue = e.target.value.replace(/\s/g, "");
    if (!isNaN(+editedValue)) {
      setPhone(editedValue.slice(-10));
    } else {
      setEmail(editedValue.toLowerCase());
    }
    setInputError(false);
  };

  const handleBack = (e) => {
    const { value, maxLength, name } = e.target;
    // eslint-disable-next-line
    const [fieldName, fieldIndex] = name.split("-");

    if (e.keyCode === 8) {
      const prevSibling = document.querySelector(
        `input[name=otp-${parseInt(fieldIndex, 10) - 1}]`
      );

      if (value.length < maxLength) {
        if (prevSibling !== null) {
          prevSibling.focus();
        }
      }
    }
  };

  const handlePaste = (e) => {
    var paste = (e.clipboardData || window.clipboardData).getData("text");
    if (paste) {
      if (parseInt(paste)) {
        paste = paste.toString().split("");
        setOtpNumber1(paste[0]);
        setOtpNumber2(paste[1]);
        setOtpNumber3(paste[2]);
        setOtpNumber4(paste[3]);
        document.querySelector(`input[name=otp-4]`).focus();
      }
    }
  };

  const generateOTP = () => {
    // track("generate_otp");
    let userContact = "";
    if (phone && phone !== null) {
      userContact = phone;
    } else if (email && email !== null) {
      userContact = email;
    }
    if (userContact && userContact !== null && userContact !== "") {
      setButtonLoader(true);
      generateOTPApi(userContact, settings.merchant, settings.otp_settings)
        .then((resp) => {
          if (resp.data.success) {
            setOtpSent(true);
            // track("otp_page_loaded");
            // track("otp_sent");
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setButtonLoader(false);
        });
    } else {
      setInputError(true);
    }
  };

  useEffect(() => {
    setOtpError(false);
  }, [otpNumber1, otpNumber2, otpNumber3, otpNumber4]);

  useEffect(() => {
    if (otpNumber4.length === 1) {
      verifyOtp();
    }
    // eslint-disable-next-line
  }, [otpNumber4]);

  const verifyOtp = () => {
    setButtonLoader(true);
    let otp =
      String(otpNumber1) +
      String(otpNumber2) +
      String(otpNumber3) +
      String(otpNumber4);

    let userContact = "";
    if (phone && phone !== null) {
      userContact = phone;
    } else if (email && email !== null) {
      userContact = email;
    }

    // track("otp_entered");

    verifyOtpApi(userContact, settings.merchant.id, otp)
      .then((resp) => {
        if (resp.data.data.verified) {
          setAccessToken(resp.data.data.token);
          setOtpVerified(true);
          // Save
          localStorage.setItem(
            "pragma_user_contact",
            JSON.stringify({ phone, email })
          );

          localStorage.setItem("pragma_access_token", resp.data.data.token);

          // id({ email: email, phone: phone });
          let iframe = document.getElementById("sessionIframe");
          iframe.contentWindow.postMessage(
            { phone: phone, email: email, topic: "PRAGMA" },
            new URL(iframe.src).origin
          );
          // track("otp_verified");
          trackOrders(resp.data.data.token);
        } else {
          setOtpError(true);
        }
      })
      .catch((err) => {
        setOtpError(true);
      })
      .finally(() => {
        setButtonLoader(false);
      });
  };

  const directOrdersFetch = () => {
    let iframe = document.getElementById("sessionIframe");
    iframe.contentWindow.postMessage(
      { phone: phone, email: email, topic: "PRAGMA" },
      new URL(iframe.src).origin
    );
    trackOrders(accessToken);
    setOtpVerified(true);
    // track("no_verfication_login");
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (buttonLoader) return;

    if (!settings.otp_settings.otp_enabled) {
      directOrdersFetch();
    } else if (otpSent) {
      verifyOtp();
    } else {
      generateOTP();
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {otpSent ? (
        <div>
          <p
            className="text-xs flex items-center justify-center mt-4"
            style={{ color: "#858A93" }}
          >
            We have sent an OTP to {phone && phone !== null ? phone : email}{" "}
            <span
              className="underline text-blue-500 text-xs flex items-center cursor-pointer"
              onClick={() => {
                // track("edit_username");
                setOtpSent(false);
                setPhone(null);
                setEmail(null);
                let iframe = document.getElementById("sessionIframe");
                iframe.contentWindow.postMessage(
                  { phone: null, email: null, topic: "PRAGMA" },
                  new URL(iframe.src).origin
                );
              }}
            >
              <FiEdit3 className="ml-1 text-xs mt-1" /> Change
            </span>
          </p>
          <div className="flex p-5 align-center justify-center">
            <input
              autoFocus
              className="w-12 h-12 text-center rounded-xl border"
              value={otpNumber1}
              style={{ appearance: "textfield" }}
              maxLength={1}
              name="otp-1"
              onChange={(e) => {
                if (e.target.value.length < 2) {
                  handleLength(e);
                  setOtpNumber1(e.target.value);
                }
              }}
              onPaste={(e) => handlePaste(e)}
              onKeyDown={(e) => handleBack(e)}
            />
            <input
              className="w-12 h-12 ml-7 text-center rounded-xl border"
              value={otpNumber2}
              maxLength={1}
              name="otp-2"
              onChange={(e) => {
                if (e.target.value.length < 2) {
                  handleLength(e);
                  setOtpNumber2(e.target.value);
                }
              }}
              onKeyDown={(e) => handleBack(e)}
            />
            <input
              className="w-12 h-12 ml-7 text-center rounded-xl border"
              value={otpNumber3}
              maxLength={1}
              name="otp-3"
              onChange={(e) => {
                if (e.target.value.length < 2) {
                  handleLength(e);
                  setOtpNumber3(e.target.value);
                }
              }}
              onKeyDown={(e) => handleBack(e)}
            />
            <input
              className="w-12 h-12 ml-7 text-center rounded-xl border"
              value={otpNumber4}
              maxLength={1}
              name="otp-4"
              onChange={(e) => {
                if (e.target.value.length < 2) {
                  handleLength(e);
                  setOtpNumber4(e.target.value);
                }
              }}
              onKeyDown={(e) => handleBack(e)}
            />
          </div>
          {otpError && (
            <p className="mt-2 text-[#d32f2f] text-xs text-center">
              Invalid Otp!
            </p>
          )}
        </div>
      ) : (
        <Fragment>
          <input
            placeholder="Enter Phone Number / Email"
            className={`rounded-xl text-sm px-4 py-3 mt-1 h-10 w-full ${
              inputError ? "border border-[#d32f2f]" : "border border-[#DFE0E1]"
            }`}
            required
            onChange={(e) => handleUser(e)}
          />
          {inputError && (
            <p className="text-[#d32f2f] text-xs mt-2">
              Please provide a valid input
            </p>
          )}
        </Fragment>
      )}
      <button
        type="submit"
        className="rounded-xl text-center w-full font-bold text-xs p-3 text-white mt-4 flex items-center justify-center"
        style={{ background: settings["--site-widget-primary-color"] }}
        disabled={buttonLoader}
      >
        {otpSent || !settings.otp_settings.otp_enabled
          ? "Verify & Track Order"
          : "Send OTP"}
        {buttonLoader && (
          <ClipLoader
            color="#fff"
            cssOverride={{ height: "14px", width: "14px", marginLeft: "10px" }}
          />
        )}
      </button>
    </form>
  );
}

export default Login;
